var React = require('react');

function Unconfirmed (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 2.5a.5.5 0 011 0c0 .193-.044.29-.084.355-.053.085-.137.173-.306.314-.02.018-.046.038-.075.061-.146.119-.382.31-.56.518-.257.3-.475.71-.475 1.252v1h2v-.958c.049-.055.105-.102.223-.198l.167-.138c.206-.171.496-.427.725-.796.241-.388.385-.853.385-1.41a2.5 2.5 0 00-5 0V3h2v-.5zM6 3.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zM7 9.222S5.833 7 3.5 7 0 9.222 0 9.222V12h7V9.222zM9.5 9a1 1 0 100-2 1 1 0 000 2z","fill":"currentColor"}));
}

Unconfirmed.defaultProps = {"fill":"none","viewBox":"0 0 12 12","width":"12px","height":"12px"};

module.exports = Unconfirmed;

Unconfirmed.default = Unconfirmed;
